import { useGetDictionaryByType } from 'api/generated/dictionary-controller/dictionary-controller';

import { useCurrentUser } from 'hooks/api/use-current-user';

import type { ProductTypeDictionary } from 'containers/user/reports/reports-utils';

interface UseProductTypesDictionaryResult {
  dictionary: ProductTypeDictionary;
  loading: boolean;
}

const useProductTypesDictionary = (): UseProductTypesDictionaryResult => {
  const currentUser = useCurrentUser();
  const oktaUserId = currentUser?.data?.oktaUserId ?? '';

  const query = useGetDictionaryByType(oktaUserId, 'PRODUCT_TYPE', {
    query: { enabled: !!oktaUserId },
  });

  const dictionary: ProductTypeDictionary =
    query.data?.reduce<ProductTypeDictionary>((acc, entry) => {
      const name = entry.name;

      if (!name) {
        return acc;
      }

      return {
        ...acc,
        [name]: { name, description: entry.description ?? '' },
      };
    }, {}) ?? {};

  return {
    dictionary,
    loading: query.isLoading,
  };
};

export default useProductTypesDictionary;
